import {
    carBatteryLanding,
    carInspection,
    freewayTollsLanding,
    motorBatteryLanding,
    motorInspection,
    trafficPlanLanding,
    vehicleFinesLanding
} from '@/constants/routes';

import { ExtraCategoryMegaMenuItem } from './models';

export const extraCategoryMegaMenuItems: ExtraCategoryMegaMenuItem[] = [
    {
        name: 'باتری',
        href: `${carBatteryLanding}/`,
        children: [
            {
                categoryId: 1,
                name: 'باتری ماشین',
                href: `${carBatteryLanding}/`
            },
            {
                categoryId: 2,
                name: 'باتری موتور',
                href: `${motorBatteryLanding}/`
            }
        ]
    },
    {
        name: 'کارشناسی',
        href: `${carInspection}/`,
        children: [
            {
                name: 'کارشناسی ماشین',
                href: `${carInspection}/`
            },
            {
                name: 'کارشناسی موتور',
                href: `${motorInspection}/`
            }
        ]
    },
    {
        name: 'استعلام',
        href: `${vehicleFinesLanding}/`,
        children: [
            {
                name: 'خلافی خودرو و موتور',
                href: `${vehicleFinesLanding}/`
            },
            {
                name: 'طرح ترافیک',
                href: `${trafficPlanLanding}/`
            },
            {
                name: 'عوارض آزادراهی',
                href: `${freewayTollsLanding}/`
            }
        ]
    }
];
